module.exports = {
  title: {
    en: 'Sabalier Law - For American Citizens With Global Ambitions',
    es: 'Sabalier Law - Para Ciudadanos Americanos con Ambiciones Globales',
  },
  description: {
    en: 'For American Citizens With Global Ambitions',
    es: 'Para Ciudadanos Americanos con Ambiciones Globales',
  },
  siteUrl: 'https://www.sabalierlaw.com',
  site: 'Sabalier Law',
  author: 'info@sabalierlaw.com',
  keywords: {
    en: ['lawyer', 'remote lawyer', 'lawyer online', 'american taxes lawyer', 'expat', 'us taxes', 'us visas'],
    es: [
      'abogado',
      'abogado remoto ',
      'abogado online',
      'abogado de impuestos americanos',
      'expat',
      'taxes',
      'us visas',
    ],
  },
  langs: [
    { key: 'en-us', label: 'en' },
    { key: 'es-es', label: 'es' },
  ],
  defaultLang: 'en-us',
  currencies: ['EUR', 'USD'],
  defaultCurrency: 'EUR',
};
